import { RETRIEVE_ALL_DISCIPLINE_SUCCESS } from '../types'

export const getAllDiscipline = data => ({
  type: RETRIEVE_ALL_DISCIPLINE_SUCCESS,
  payload: data
})
